export default __webpack_public_path__ + "static/media/company-img.624ef318.png";